(function () {
    "use strict";

    // @ngInject
    function ReportsPaymentsControllerCtor($scope, $injector, $filter, $timeout, moment, $sce, $q, $stateParams, _,
                                           InitialAppLoadParamsService, WorkspaceFileService, PopupMessageService,
                                           AnalyticsService , UiPersistenceService, FeaturesService, ModalService,
                                           OnboardingService, UsersManager, ReportsManager, CompaniesManager, WorkspaceFilesManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ReportsPaymentsController';
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.WorkspaceFileService = WorkspaceFileService;
        this.AnalyticsService = AnalyticsService;
        this.ReportsManager = ReportsManager;
        this.PopupMessageService = PopupMessageService;
        this.FeaturesService = FeaturesService;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this._ = _;
        this.$q = $q;
        this.moment = moment;
        this.$stateParams = $stateParams;
        this.loadingReports = false;
        this.currUser = UsersManager.getCurrUser();
        this.debitCard = this.currUser.myDebitCard();
        this.isHbAdmin = !!this.currUser.is_hb_admin;
        this.isCompanyAdmin = this.currUser.hasCompanyAdminPermissions();
        this.paymentsReminderInProgress = {};
        this.UiPersistenceService = UiPersistenceService;
        this.$sce = $sce;
        this.ModalService = ModalService;
        this.OnboardingService = OnboardingService;
        this.instantDepositsTimeFrame = 24 * 3600;

        this.invoice_id = InitialAppLoadParamsService.getParamAndRemove('invoice');
        this.workspace_file_id = InitialAppLoadParamsService.getParamAndRemove('wid');

        this.company = CompaniesManager.getCurrCompany();
        if (this.company.wasFullyFetched()) {
            this.gotCompany();
        }
        this.register(this.company, 'success', this.gotCompany);

        this.outstandingPaymentsFilters = {
            all: {index: 1, key: 'all', resource: 'REPORTS.PAYMENTS.FILTERS._ALL_', start: moment().add(-30, 'years'), end: moment().add(30, 'years')},
            overdue: {index: 2, key: 'overdue', resource: 'REPORTS.PAYMENTS.FILTERS._OVERDUE_', start: moment().add(-30, 'years'), end: moment().add(-1, 'days')},
            nextWeek: {index: 3, key: 'nextWeek', resource: 'REPORTS.PAYMENTS.FILTERS._NEXT_WEEK_', start: moment().add(-1, 'days'), end: moment().add(1, 'weeks')},
            nextMonth: {index: 4, key: 'nextMonth', resource: 'REPORTS.PAYMENTS.FILTERS._NEXT_MONTH_', start: moment().add(-1, 'days'), end: moment().add(1, 'months')},
            nextYear: {index: 5, key: 'nextYear', resource: 'REPORTS.PAYMENTS.FILTERS._NEXT_YEAR_', start: moment().add(-1, 'days'), end: moment().add(1, 'years')}
        };

        this.outstandingPaymentsFiltersArray = this._.values(this.outstandingPaymentsFilters);
        this.outstandingPaymentsActiveFilter = this.outstandingPaymentsFiltersArray[0];

        this.paidPaymentsFilters = {
            all: {index: 1, key: 'all', resource: 'REPORTS.PAYMENTS.FILTERS._ALL_', start: moment().add(-30, 'years'), end: moment().add(30, 'years')},
            recently: {index: 2, key: 'recently', resource: 'REPORTS.PAYMENTS.FILTERS._RECENTLY_', start: moment().add(-2, 'months'), end: moment().add(1, 'days')},
            lastSixMonths: {index: 3, key: 'lastSixMonths', resource: 'REPORTS.PAYMENTS.FILTERS._LAST_SIX_MONTHS_', start: moment().add(-6, 'months'), end: moment().add(1, 'days')},
            pastYear: {index: 4, key: 'pastYear', resource: 'REPORTS.PAYMENTS.FILTERS._PAST_YEAR_', start: moment().add(-1, 'years'), end: moment().add(1, 'days')}
        };

        this.paidPaymentsFiltersArray = this._.values(this.paidPaymentsFilters);
        this.paidPaymentsActiveFilter = this.paidPaymentsFiltersArray[0];

        this.loadPayments();
        
        this.setActiveOutstandingPaymentsFilter = function setActiveOutstandingPaymentsFilter(filterName) {
            this.outstandingPaymentsActiveFilter = this.outstandingPaymentsFilters[filterName];
        }.bind(this);

        this.setActivePaidPaymentsFilter = function setActivePaidPaymentsFilter(filterName) {
            this.paidPaymentsActiveFilter = this.paidPaymentsFilters[filterName];
        }.bind(this);

        this.filterOutstandingPayments = function filterOutstandingPayments(payment) {
            var date = moment(payment.payment_due_date);
            return (date.isBetween(this.outstandingPaymentsActiveFilter.start, this.outstandingPaymentsActiveFilter.end));
        }.bind(this);

        this.filterPaidPayments = function filterPaidPayments(payment) {
            var date = moment(payment.payment_charge_date);
            return (date.isBetween(this.paidPaymentsActiveFilter.start, this.paidPaymentsActiveFilter.end));
        }.bind(this);

    }

    Controllers.ReportsPaymentsController = Class(Controllers.BaseController, {

        constructor: ReportsPaymentsControllerCtor,

        loadPayments: function loadPayments() {
            this.payments = {};
            this.loadingReports = true;

            this.ReportsManager.getReportsPayments().then(function success(resp) {
                this.payments = resp.data;
                this.initialize();
            }.bind(this)).catch(function error(resp) {
                this.lastError = resp.data.error_message || resp.data;
            }.bind(this)).finally(function() {
                this.loadingReports = false;
            }.bind(this));
        },

        initialize: function initialize() {
            var self = this;

            this.paidPayments = this.payments.paid_payments;
            if(this.paidPayments) {
                this.paidPayments.forEach(function (payment) {
                    payment.fileStatus = self.WorkspaceFileService.getStatusLabelForVendor(payment.file_type_cd, payment.file_status_cd);
                    payment.file_type = self.WorkspaceFileService.getFileType(payment.file_type_cd);
                    payment.estimated_payout_label = this._getPayoutLabel(payment);
                }.bind(this));
            }

            this.outstandingPayments = [];
            if(this.payments.late_payments){
                this.payments.late_payments.forEach(function (payment){
                    payment.status = 'late';
                    payment.fileStatus = self.WorkspaceFileService.getStatusLabelForVendor(payment.file_type_cd, payment.file_status_cd);
                    payment.file_type = self.WorkspaceFileService.getFileType(payment.file_type_cd);
                    payment.estimated_payout_label = this._getPayoutLabel(payment);
                }.bind(this));

                this.outstandingPayments = this.outstandingPayments.concat(this.payments.late_payments);
            }

            if(this.payments.due_payments){
                this.payments.due_payments.forEach(function (payment){
                    payment.status = 'unpaid';
                    payment.fileStatus = self.WorkspaceFileService.getStatusLabelForVendor(payment.file_type_cd, payment.file_status_cd);
                    payment.file_type = self.WorkspaceFileService.getFileType(payment.file_type_cd);
                    payment.estimated_payout_label = this._getPayoutLabel(payment);
                }.bind(this));
                this.outstandingPayments = this.outstandingPayments.concat(this.payments.due_payments);
            }

            if(this.payments.imminent_payments){
                this.payments.imminent_payments.forEach(function (payment){
                    payment.status = 'upcoming';
                    payment.fileStatus = self.WorkspaceFileService.getStatusLabelForVendor(payment.file_type_cd, payment.file_status_cd);
                    payment.file_type = self.WorkspaceFileService.getFileType(payment.file_type_cd);
                    payment.estimated_payout_label = this._getPayoutLabel(payment);
                }.bind(this));
                this.outstandingPayments = this.outstandingPayments.concat(this.payments.imminent_payments);
            }

            if(this.payments.pending_payments){
                this.payments.pending_payments.forEach(function (payment){
                    payment.status = 'pending';
                    payment.fileStatus = self.WorkspaceFileService.getStatusLabelForVendor(payment.file_type_cd, payment.file_status_cd);
                    payment.file_type = self.WorkspaceFileService.getFileType(payment.file_type_cd);
                    payment.estimated_payout_label = this._getPayoutLabel(payment);
                }.bind(this));
                this.outstandingPayments = this.outstandingPayments.concat(this.payments.pending_payments);
            }

            // Filters handling
            this.outstandingPaymentsActiveFilter = this.outstandingPaymentsFilters.all;
            this.paidPaymentsActiveFilter = this.paidPaymentsFilters.all;

            this.outstandingPaymentsLimit = 5;
            this.hasMoreOutstanding = this.outstandingPaymentsLimit < this.outstandingPayments.length;

            this.paidPaymentsLimit = 5;
            this.hasMorePaid = this.paidPayments && (this.paidPaymentsLimit < this.paidPayments.length);

            if (this.$stateParams.section) {
                this.scrollToSection(this.$stateParams.section);
            }
        },

        syncToQuickbooks: function syncToQuickbooks($event, payment, force_invoice_creation) {

            this.quickbooksSyncsInProgress = this.quickbooksSyncsInProgress || {};

            if (this.quickbooksSyncsInProgress[payment.workspace_file_id]) {
                return;
            }

            $event.preventDefault();
            $event.stopPropagation();

            var promise = null;

            if (!this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.hideQBSyncModal, {hide: false}).hide) {
                promise = this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, 'REPORTS.PAYMENTS._ALL_FILES_ARE_SYNCED_WARNING_', 'got it');
            }
            else {
                promise = this.$q.when();
            }

            promise.then(function() {
                this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.hideQBSyncModal, {hide: true});
                this.quickbooksSyncsInProgress[payment.workspace_file_id] = true;

                this.WorkspaceFilesManager.syncToQuickbooks(payment.workspace_file_id, force_invoice_creation).then(function success(resp) {
                    // We must change the quickbooks id for all the payments of this file

                    var qbPaymentsMapById = {};
                    angular.forEach(resp.data.payments_container.payments, function(payment) {
                        if (payment.payment_quickbooks_data_container) {
                            qbPaymentsMapById[payment._id] = payment.payment_quickbooks_data_container.quickbooks_payment_id;
                        }
                    });

                    this.paidPayments.forEach(function(p) {
                        if (p.workspace_file_id === payment.workspace_file_id && qbPaymentsMapById[p._id]) {
                            p.payment_quickbooks_integration_id = qbPaymentsMapById[p._id];
                        }
                    });
                }.bind(this))
                    .catch(function error(resp) {
                        if (resp && resp.data && resp.data.error_type && resp.data.error_type === 'HBQBInvoiceNotFoundError') {
                            // Invoice that we tried to update is missing on QB database. Notify vendor and request a confirmation to create a new invoice

                            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info, 'The invoice you are attempting to sync with cannot be located in your Quickbooks account. Would you like to create a new invoice for this file?',
                                function confirm() {
                                    this.syncToQuickbooks($event, payment, true);
                                }.bind(this),
                                function cancel() {

                                }.bind(this),
                                'FREQUENT_BUTTONS._CREATE_',
                                'FREQUENT_BUTTONS._CANCEL_'
                            );
                        }
                        else {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                        }
                    }.bind(this))
                    .finally(function final() {
                        this.quickbooksSyncsInProgress[payment.workspace_file_id] = false;
                    }.bind(this));
            }.bind(this));
        },

        showMoreOutstandingPayments: function showMoreOutstandingPayments(){
            this.outstandingPaymentsLimit += 50;
            this.hasMoreOutstanding = this.outstandingPaymentsLimit < this.outstandingPayments.length;
        },

        showMorePaidPayments: function showMorePaidPayments(){
            this.paidPaymentsLimit += 50;
            this.hasMorePaid = this.paidPaymentsLimit < this.paidPayments.length;
        },

        isPaidAndDisputeReserved: function isPaidAndDisputeReserved(paymentData){
            return paymentData.payment_is_paid && paymentData.payment_dispute_amount_reversed > 0;
        },

        isPaidAndProcessedForDispute: function isPaidAndProcessedForDispute(paymentData){
            return paymentData.payment_is_paid && paymentData.payment_dispute_amount_reversed_lost > 0;
        },

        isPaymentPaid: function isPaymentPaid(paymentData) {
            return paymentData.payment_is_paid && (!paymentData.payment_refund_is_refunded && !paymentData.payment_refund_is_pending && !paymentData.payment_refund_is_error);
        },

        isPaymentRefundable: function isPaymentRefundable(paymentData) {
            return this.isPaymentPaid(paymentData) && paymentData;
        },

        isPaymentRefunded: function isPaymentRefunded(paymentData) {
            return !!paymentData.payment_refund_is_refunded;
        },

        isPaymentPartiallyRefunded: function isPaymentPartiallyRefunded(paymentData) {
            return !!paymentData.payment_refund_is_refunded && paymentData.payment_refund_amount < paymentData.payment_amount;
        },

        isPaymentRefundPending: function isPaymentRefundPending(paymentData) {
            return !!paymentData.payment_refund_is_pending;
        },

        isPaymentRefundError: function isPaymentRefundError(paymentData) {
            return !!paymentData.payment_refund_is_error;
        },

        onRefundClick: function onRefundClick(payment, $event) {
            $event.preventDefault();

            if (!this.verifyRefundValid(payment)) {
                return;
            }

            this.ModalService.openRefundPaymentModal({
                _id: payment._id,
                amount: payment.payment_amount,
                tip_paid: payment.payment_tip_paid,
                transferred_to_vendor: payment.payment_transferred_to_vendor,
                is_manual: payment.is_manual,
                charge_date: payment.payment_charge_date
            }, payment.workspace_file_id).then(this.loadPayments.bind(this));
        },

        verifyRefundValid: function verifyRefundValid(payment) {

            var isOwnerMode = (this.currUser._id === payment.owner_id || (this.currUser.company._id === payment.company_id && this.currUser.hasCompanyAdminPermissions()));
            var isCanceled = !!payment.file_canceled;
            var isWorkspaceArchived = (payment.inactive_users && payment.inactive_users.indexOf(this.currUser._id) !== -1);
            var isFileDraft = payment.is_draft_editable && !payment.is_manual;

            var error = null;
            var valid = false;

            if (!isOwnerMode) {
                error = 'REPORTS.PAYMENTS._REFUND_NOT_OWNER_ERROR_';
            } else if (isCanceled) {
                error = 'REPORTS.PAYMENTS._REFUND_CANCELED_ERROR_';
            } else if (isWorkspaceArchived) {
                error = 'REPORTS.PAYMENTS._REFUND_WORKSPACE_ARCHIVED_ERROR_';
            } else if (isFileDraft) {
                error = 'REPORTS.PAYMENTS._REFUND_EDITABLE_DRAFT_ERROR_';
            } else {
                valid = true;
            }

            if (!valid) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, error);
            }
            
            return valid;
        },


        getPaymentLabelKey: function(paymentData) {
            if (this.isPaidAndDisputeReserved(paymentData)) {
                return 'REPORTS.PAYMENTS._DISPUTE_RESERVED_';
            } else if (this.isPaidAndProcessedForDispute(paymentData)) {
                return 'REPORTS.PAYMENTS._DISPUTE_RESERVED_LOST_';
            } else if (this.isPaymentPaid(paymentData)) {
                return 'REPORTS.PAYMENTS._PAID_';
            } else if (this.isPaymentPartiallyRefunded(paymentData)) {
                return 'REPORTS.PAYMENTS._PARTIALLY_REFUNDED_';
            } else if (this.isPaymentRefunded(paymentData)) {
                return 'REPORTS.PAYMENTS._REFUNDED_';
            } else if (this.isPaymentRefundPending(paymentData)) {
                return 'REPORTS.PAYMENTS._REFUND_PENDING_';
            } else if (this.isPaymentRefundError(paymentData)) {
                return 'REPORTS.PAYMENTS._REFUND_ERROR_';
            } else {
                // Should never hit this...
                return 'REPORTS.PAYMENTS._PAID_';
            }
        },

        getPaymentLabelClass: function(paymentData) {
            if (this.isPaymentPaid(paymentData)) {
                return 'active-paid-icon';
            } else if (this.isPaymentPartiallyRefunded(paymentData)) {
                return 'active-partially-refunded-icon';
            } else if (this.isPaymentRefunded(paymentData)) {
                return 'active-refunded-icon';
            } else if (this.isPaymentRefundPending(paymentData)) {
                return 'active-refund-pending-icon';
            } else if (this.isPaymentRefundError(paymentData)) {
                return 'active-refund-error-icon';
            } else {
                // Should never hit this...
                return 'active-paid-icon';
            }
        },

        sendPaymentReminder: function sendPaymentReminder(payment) {

            if (!payment.file_sent_on) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.warning, 'you can\'t send a reminder for an unsent ' + payment.file_type);
                return;
            }

            if (this.paymentsReminderInProgress[payment._id]) {
                return;
            }

            this.paymentsReminderInProgress[payment._id] = true;

            this.ReportsManager.sendPaymentReminder(payment.workspace_file_id, payment).then(
                function success() {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.payment_reminder_sent, {
                        source: 'reports',
                        payment_id: payment._id
                    });
                }.bind(this)
            ).catch(
                function error(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.payment_reminder_error, resp, {
                        source: 'reports',
                        payment_id: payment._id
                    });
                }.bind(this)
            ).finally(function final() {
                this.paymentsReminderInProgress[payment._id] = false;
            }.bind(this));
        },

        clickToggleInstantDeposit: function clickToggleInstantDeposit(e) {
            e.stopPropagation();
            if(!this.debitCard) {
                this.openDebitCardModal();
            }
        },

        openDebitCardModal: function openDebitCardModal(workspaceFileId, invoiceId) {
            this.ModalService.openAddDebitCardModal('bookkeeping').then(
                function onSuccess(){
                    this.debitCard = this.currUser.myDebitCard();
                    if(this.debitCard && workspaceFileId && invoiceId) {
                        // deposit now fow
                        this.openInstantDepositModal('debit card modal', workspaceFileId, invoiceId);
                    }
                }.bind(this)
            ).catch(
                function onFailure(resp){
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.open_debit_card_modal, resp);
                }.bind(this));
        },

        allowChargedInstantDeposit: function allowChargedInstantDeposit(payment) {
            return (!payment.use_instant_payout) && payment.allow_instant_payout &&
                payment.allow_charged_instant_payout;
        },

        isWithinTimeFrame: function isWithinTimeFrame(chargeDate) {
            var maxDateForInstant = this.moment(chargeDate).add(1, 'days');
            return this.moment().isBefore(maxDateForInstant);
        },

        togglePaymentInstantPayout: function togglePaymentInstantPayout(payment) {
            if(this.debitCard) {
                this.WorkspaceFilesManager.markPaymentAsInstantPayout(payment.workspace_file_id, payment._id, payment.use_instant_payout).then(
                    function onSuccess(resp) {
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.toggle_instant_payment, {newState: payment.use_instant_payout});
                    }.bind(this)
                ).catch(
                    function onError(resp) {
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.toggle_instant_payment, resp);
                        if(resp.data && resp.data.error_message) {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                        } else {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNKNOWN_');
                        }
                    }.bind(this));
            }
        },

        onDepositNowClick: function onDepositNowClick(event, payment) {
            event.stopPropagation();
            if(!this.debitCard) {
                this.openDebitCardModal(payment.workspace_file_id, payment.payment_invoice);
            } else {
                this.openInstantDepositModal('bookkeeping', payment.workspace_file_id, payment.payment_invoice);
            }
        },

        openInstantDepositModal: function openInstantDepositModal(source, workspaceFileId, invoiceId) {
            this.ModalService.openInstantDepositModal(source, workspaceFileId, invoiceId).then(
                function onSuccess() {
                    this.loadPayments();
                }.bind(this)
            ).catch(
                function onFailure() {

                }.bind(this)
            );
        },

        calcInstantDepositCharge: function calcInstantDepositCharge(amount) {
            var fee = Math.round(amount + 0.00001)  * 0.01;
            fee = fee % 1 !== 0 ? fee : fee.toFixed(2);
            return fee > 5 ? fee : 5;
        },

        gotCompany: function gotCompany() {
            this.showQuickbooksBanner = !this.company.quickbooks_integration;
            // show instant deposit. will not succeed if allow_instant_payout will be falsey.
            // note: eligible_for_instant_payouts is actually enough, left allow_instant_payouts to avoid reload
            this.showInstantDeposit = !!this.currUser.myBankAccount() && (this.company.eligible_for_instant_payouts || this.company.allow_instant_payouts);
            // if eligible but not allowed, its paused (disputes, recollections, fraud, etc.)
            this.instantDepositPaused =
                this.company.eligible_for_instant_payouts &&
                !this.company.allow_instant_payouts;

            this.showInstantDepositsIntro = this.showInstantDeposit &&
                this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.instantDeposits, {show: true}).show;
            if(this.workspace_file_id && this.invoice_id) {
                // loaded with context file and invoice, meaning its a click from a "deposit now" flow
                if(!this.debitCard) {
                    this.openDebitCardModal(this.workspace_file_id, this.invoice_id);
                } else {
                    this.openInstantDepositModal('email', this.workspace_file_id, this.invoice_id);
                }
            }
        },

        hideInstantDepositsIntro: function hideInstantDepositsIntro() {
            this.showInstantDepositsIntro =  false;
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.instantDeposits, {show: this.showInstantDepositsIntro});
        },

        hideQuickbooksNotification: function hideQuickbooksNotification() {
            this.showQuickbooksBanner = false;
        },

        reminderInProgress: function reminderInProgress(payment) {
            return this.paymentsReminderInProgress[payment._id] === true;
        },

        _getPayoutLabel: function _getPayoutLabel(payment) {
            return "Est. deposit: " + this.$filter('date')(payment.estimated_payout_date, 'MMM dd', 'UTC');
        },

        scrollToSection: function scrollToSection(section) {
            this.$timeout(function () {
                var elm = $('#' + section);
                $("html, body").animate({scrollTop: elm.offset().top - 180}, 300);
            }, 1000);
        },

        invoiceNumberSmall: function invoiceNumberSmall(invoice) {
            if (invoice) {
                return '#' + invoice.slice(0, 1) + '...' + invoice.slice(-3)
            }
        },

        toggleAccordion: function toggleAccordion() {
            this.isOpen = !this.isOpen;
        },

        shouldShowUnsync: function shouldShowUnsync(payment) {
            return this.currUser.isAdminLogin() && !!(payment.payment_quickbooks_integration_id);
        },

        onClickUnsync: function onClickUnsync(payment) {
            this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.warning,
                'Are you sure you want to unsync this QB payment?').then(function yes() {
                this.unsyncConfirmed(payment).catch(function fail(e) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, e.data.error_message);
                }.bind(this));
            }.bind(this));
        },

        unsyncConfirmed: function unsyncConfirmed(payment) {
            this.quickbooksSyncsInProgress = this.quickbooksSyncsInProgress || {};

            if (this.quickbooksSyncsInProgress[payment.workspace_file_id]) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, "Unsync already in progress. Refresh the page if not resolved");
                return;
            }

            this.quickbooksSyncsInProgress[payment.workspace_file_id] = true;

            this.WorkspaceFilesManager.unsyncQbPayment(payment.workspace_file_id, payment._id).then(function success(resp) {
                payment.payment_quickbooks_integration_id = null;

            }.bind(this))
                .catch(function error(resp) {
                    if (resp && resp.data && resp.data.error_type) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                    } else {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, "Not working :(");
                    }
                }.bind(this))
                .finally(function final() {
                    this.quickbooksSyncsInProgress[payment.workspace_file_id] = false;
                }.bind(this));
        },

        showEstimatedPayoutDate: function showEstimatedPayoutDate(payment) {
            return payment.estimated_payout_date &&
                payment.estimated_payout_date !== null &&
                !this.isPaidAndProcessedForDispute(payment) &&
                !this.isPaidAndDisputeReserved(payment)
        }
    });
}());
